import axios from 'axios'
import {CredentialUrls} from '../urls'
import router from '../../../router'
import {memberUrls} from "../../MemberService/urls";
import {donationUrls} from "../../DonationService/urls";
import {volunteerUrls} from "../../VolunteerService/urls";

export default {
  get_all_credentials (context) {
    axios.get(CredentialUrls.getAllCredentials).then(function (response) {
      context.commit('GET_ALL_CREDENTIALS', response.data)
      context.dispatch('loading_false')
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_ALL_CREDENTIALS', data)
      context.dispatch('loading_false')
    })
  },
  get_deleted_credentials (context) {
    axios.get(CredentialUrls.getDeletedCredentials).then(function (response) {
      context.commit('GET_DELETED_CREDENTIALS', response.data)
      context.dispatch('loading_false')
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_DELETED_CREDENTIALS', data)
      context.dispatch('loading_false')
    })
  },
  get_credential (context, publicId) {
    axios.get(CredentialUrls.getCredential + publicId).then(function (response) {
      context.commit('GET_CREDENTIAL', response.data)
      context.dispatch('loading_false')
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_CREDENTIAL', data)
      context.dispatch('loading_false')
    })
  },
  post_credential (context, data) {
    axios.post(CredentialUrls.postCredential, data).then(function (response) {
      context.dispatch('loading_false')
    })
  },
  trigger_salesforce_integration (context, data) {
    axios.post(CredentialUrls.pushVisitRecords, data).then((response) => {
      if (response.status === 200) {
        context.dispatch('loading_false')
      }
    })
    axios.get(memberUrls.pushMembershipRecords).then((response) => {
      if (response.status === 200) {
        context.dispatch('loading_false')
      }
    })
    axios.get(donationUrls.pushDonationRecords).then((response) => {
      if (response.status === 200) {
        context.dispatch('loading_false')
      }
    })
    axios.get(volunteerUrls.pushVolunteerRecords).then((response) => {
      if (response.status === 200) {
        context.dispatch('loading_false')
      }
    })
  },
  update_credential (context, data) {
    axios.patch(CredentialUrls.editCredential, data).then(function (response) {
      context.dispatch('get_all_credentials')
      router.push({
        name: data.redirect_url
      })
      context.dispatch('loading_false')
     })
  },
  delete_credential (context, publicId) {
    axios.delete(CredentialUrls.deleteCredential + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_CREDENTIALS', response.data)
      router.push({
        name: 'Module.DeletedCredentials'
      })
      context.dispatch('loading_false')
    })
  },
  restore_credential (context, publicId) {
    axios.get(CredentialUrls.restoreCredential + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_CREDENTIALS', response.data)
      router.push({
        name: 'Module.Credentials'
      })
      context.dispatch('loading_false')
    })
  }
}
